import React from "react"

import ContentLines from "../../common/content-loading/ContentLines"
import ContentTags from "../../common/content-loading/ContentTags"
import ListItemImageShadow from "../../common/content-loading/ListItemImageShadow"

export default () => (
    <div className="list-group-item">
        <ListItemImageShadow />
        <div className="list-group-item-content">
            <ContentLines minLineLength={30} />
            <ContentLines />
            <ContentLines lineLength={40} />
            <ContentTags tags={1} />
        </div>
    </div>
)
